var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAidata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_1570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 24.0013C22.85 24.0013 24.0013 22.85 24.0013 21.4297C24.0013 20.0095 22.85 18.8582 21.4297 18.8582C20.0095 18.8582 18.8582 20.0095 18.8582 21.4297C18.8582 22.85 20.0095 24.0013 21.4297 24.0013Z",
    stroke: "#75B4FF",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71471 6.00037H18.001C18.9103 6.00037 19.7824 6.36161 20.4255 7.00462C21.0685 7.64764 21.4297 8.51976 21.4297 9.42912C21.4297 10.3385 21.0685 11.2106 20.4255 11.8536C19.7824 12.4966 18.9103 12.8579 18.001 12.8579H7.71471C6.57801 12.8579 5.48786 13.3094 4.68409 14.1132C3.88032 14.917 3.42877 16.0071 3.42877 17.1438C3.42877 18.2805 3.88032 19.3707 4.68409 20.1744C5.48786 20.9782 6.57801 21.4297 7.71471 21.4297H18.8581",
    stroke: "#75B4FF",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_1570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.43,
    height: 27.43,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidata);
export default __webpack_public_path__ + "static/media/aidata.9d745a3b5a7b8c39b955ec97908acbb8.svg";
export { ForwardRef as ReactComponent };